import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import HomePage from "@/pages/HomePage";
import SaviPage from "@/pages/SaviPage";
import PortfolioPage from "@/pages/PortfolioPage";
import FrameworkPage from "@/pages/FrameworkPage";
import KnowledgeCentrePage from "@/pages/KnowledgeCentrePage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import ReachUsPage from "@/pages/ReachUsPage";
import {
  SaviWhatPage,
  SaviWhyPage,
  SaviHowPage,
} from "@/pages/PlaceholderPages";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/savi" element={<SaviPage />} />
            <Route path="/savi/what" element={<SaviWhatPage />} />
            <Route path="/savi/why" element={<SaviWhyPage />} />
            <Route path="/savi/how" element={<SaviHowPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/framework" element={<FrameworkPage />} />
            <Route path="/knowledge-centre" element={<KnowledgeCentrePage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/reach-us" element={<ReachUsPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
